import { render, staticRenderFns } from "./en-sentenceModfiyPage.vue?vue&type=template&id=f25f5b5c&scoped=true&"
import script from "./en-sentenceModfiyPage.vue?vue&type=script&lang=js&"
export * from "./en-sentenceModfiyPage.vue?vue&type=script&lang=js&"
import style0 from "./en-sentenceModfiyPage.vue?vue&type=style&index=0&id=f25f5b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25f5b5c",
  null
  
)

export default component.exports